import React from "react";
import "./InputBarangJadi.css";
import { useInputBarangJadi } from "./useInputBarangJadi";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import Select from "react-select";
import RefreshIcon from "../../Assets/refresh-icon.png";
import { hasRole } from "../../util/utilFunction";

/* ------------------------------------------------------------------ */
/* Helper                                                              */
/* ------------------------------------------------------------------ */

const formatDot = (value) =>
  value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

// Warna kolom OK: hijau = barang masuk, merah = barang keluar
const okClass = (e) => {
  if (!e) return "ibj_pos";
  if (e.statusBahan === "Datang") return "ibj_pos";
  if (e.statusBahan === "Kiriman") return "ibj_neg";
  if (e.statusBahan === "Produksi" && !e.status) return "ibj_pos";
  if (e.statusBahan === "Keluar") return "ibj_neg";
  if (e.statusBahan === "Produksi" && e.status === "Keluar") return "ibj_neg";
  return "ibj_pos";
};

// Samakan tampilan react-select dengan input lain
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 40,
    borderRadius: 8,
    borderWidth: 1.5,
    borderColor: state.isFocused ? "#2d357a" : "#dcdff2",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(45, 53, 122, 0.14)" : "none",
    "&:hover": { borderColor: "#2d357a" },
  }),
  menu: (base) => ({ ...base, zIndex: 20 }),
};

/* ------------------------------------------------------------------ */
/* Komponen kecil                                                      */
/* ------------------------------------------------------------------ */

const Field = ({ label, required, wide, full, children }) => {
  const cls = ["ibj_field", wide && "ibj_field_wide", full && "ibj_field_full"]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls}>
      <p className="ibj_label">
        {label}
        {required && <span className="ibj_required">*</span>}
      </p>
      {children}
    </div>
  );
};

const RadioOption = ({ value, label, checked, onSelect }) => (
  <label className={checked ? "ibj_radio ibj_radio_checked" : "ibj_radio"}>
    <input
      type="radio"
      value={value}
      checked={checked}
      onChange={() => onSelect(value)}
    />
    <span>{label}</span>
  </label>
);

const PopUpMessage = ({ message, error, onClose }) => (
  <PopUpComponent>
    <p className={error ? "ibj_error_text" : ""}>{message}</p>
    <div className="ibj_popup_footer">
      <button className="ibj_btn_primary" onClick={onClose}>
        OK
      </button>
    </div>
  </PopUpComponent>
);

/* ------------------------------------------------------------------ */
/* Halaman                                                             */
/* ------------------------------------------------------------------ */

const InputBarangJadi = () => {
  const {
    dataUser,
    popUpSubmit,
    popUpErrorSubmit,
    setCompanyPickInputGbj,
    setJumlahInputGbj,
    setKeteranganGbj,
    jumlahInputGbj,
    keteranganGbj,
    companyPickInputGbj,
    dataListBarangJadi,
    reFormat,
    setProdukPick,
    produkPick,
    handleKirimInputGbj,
    setPopUpSubmit,
    setPopUpErrorSubmit,
    filterDate,
    setFilterDate,
    historyBarangJadiAksesoris,
    dateSubmitBarangJadi,
    setDateSubmitBarangJadi,
    produkPickFilter,
    setProdukPickFilter,
    dataTemp,
    filterStatus,
    setFilterStatus,
    setStatusBarang,
    statusBarang,
    setIsReload,
    jumlahNgInputGbj,
    setJumlahNgInputGbj,
    filterLevel,
    setFilterLevel,
  } = useInputBarangJadi();

  const canInput = hasRole(
    dataUser,
    "warehouse_gbj_admin",
    "super_user",
    "ppic_user",
    "pr_admin"
  );

  // opsi filter produk (unik)
  const dataFilterProduk = [];
  historyBarangJadiAksesoris &&
    historyBarangJadiAksesoris.forEach((element) => {
      dataFilterProduk.push({
        label: element.material,
        value: element.material,
      });
    });

  const resultReduce = dataFilterProduk.reduce((unique, o) => {
    if (!unique.some((obj) => obj.label === o.label && obj.value === o.value)) {
      unique.push(o);
    }
    return unique;
  }, []);

  const handleReset = () => {
    setFilterStatus("Status");
    setProdukPickFilter("");
    setFilterLevel("Level");
  };

  const sum =
    dataTemp &&
    dataTemp.reduce(function (s, a) {
      return s + a.dataWeight;
    }, 0);

  const statusOptions = [
    { value: "NonProduksi", label: "Outgoing" },
    { value: "Datang", label: "Datang" },
    { value: "Kiriman", label: "Kiriman" },
    { value: "Produksi", label: "Line Produksi (Injeksi / SP)" },
  ];

  return (
    <div className="container_dashboard">
      {popUpSubmit && (
        <PopUpMessage
          message="Terima Kasih! Anda Telah Men-update Stock Masuk Bahan."
          onClose={() => setPopUpSubmit(false)}
        />
      )}
      {popUpErrorSubmit && (
        <PopUpMessage
          error
          message="Mohon pastikan semua kolom yang Berbintang Merah Terisi !"
          onClose={() => setPopUpErrorSubmit(false)}
        />
      )}

      <p className="ibj_title">INPUT GUDANG BARANG JADI</p>

      {/* ===================== FORM INPUT ===================== */}
      {canInput && (
        <div className="ibj_card">
          <div className="ibj_form">
            <Field label="Pilih Tanggal">
              <input
                type="date"
                className="ibj_input"
                value={dateSubmitBarangJadi}
                onChange={(e) => setDateSubmitBarangJadi(e.target.value)}
              />
            </Field>

            <Field label="Status Barang" required full>
              <div className="ibj_radio_group">
                {statusOptions.map((opt) => (
                  <RadioOption
                    key={opt.value}
                    value={opt.value}
                    label={opt.label}
                    checked={statusBarang === opt.value}
                    onSelect={setStatusBarang}
                  />
                ))}
              </div>
            </Field>

            <Field label="Perusahaan" required>
              <select
                className="ibj_select"
                value={companyPickInputGbj || ""}
                onChange={(e) => setCompanyPickInputGbj(e.target.value)}
              >
                <option value="" disabled>
                  Pilih Nama Perusahaan
                </option>
                {dataListBarangJadi &&
                  dataListBarangJadi.map((data, i) => (
                    <option value={data.company} key={i}>
                      {data.company}
                    </option>
                  ))}
              </select>
            </Field>

            <Field label="Nama Barang" required wide>
              <Select
                options={reFormat}
                value={produkPick || ""}
                onChange={setProdukPick}
                styles={selectStyles}
              />
            </Field>

            {statusBarang !== "NonProduksi" && (
              <Field label="OK (Pcs)" required>
                <input
                  type="number"
                  className="ibj_input"
                  placeholder="Masukkan Jumlah (Pcs)"
                  value={jumlahInputGbj}
                  onChange={(e) => setJumlahInputGbj(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </Field>
            )}

            {statusBarang !== "Kiriman" && statusBarang !== "Datang" && (
              <Field label="NG (Pcs)">
                <input
                  type="number"
                  className="ibj_input"
                  placeholder="Masukkan Jumlah (Pcs)"
                  value={jumlahNgInputGbj || ""}
                  onChange={(e) => setJumlahNgInputGbj(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </Field>
            )}

            <Field label="Keterangan" full>
              <textarea
                className="ibj_textarea"
                placeholder="Masukkan Keterangan Jika Diperlukan"
                onChange={(e) => setKeteranganGbj(e.target.value.toUpperCase())}
                value={keteranganGbj}
              />
            </Field>
          </div>

          <div className="ibj_form_footer">
            <button
              className="ibj_btn_primary"
              onClick={() => handleKirimInputGbj()}
            >
              Kirim
            </button>
          </div>
        </div>
      )}

      {/* ===================== RIWAYAT ===================== */}
      <div className="ibj_filter_bar">
        <div className="ibj_filter_item">
          <p className="ibj_label">Pilih Tanggal</p>
          <input
            type="date"
            className="ibj_input"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
          />
        </div>

        <div className="ibj_filter_item ibj_filter_wide">
          <p className="ibj_label">Pilih Produk</p>
          <Select
            options={resultReduce}
            value={produkPickFilter || ""}
            onChange={setProdukPickFilter}
            styles={selectStyles}
          />
        </div>

        <div className="ibj_filter_item">
          <p className="ibj_label">Status</p>
          <select
            className="ibj_select"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value="Status" disabled>
              Status
            </option>
            <option value="Masuk">Masuk</option>
            <option value="Keluar">Keluar</option>
          </select>
        </div>

        <div className="ibj_filter_item">
          <p className="ibj_label">Level</p>
          <select
            className="ibj_select"
            value={filterLevel}
            onChange={(e) => setFilterLevel(e.target.value)}
          >
            <option value="Level" disabled>
              Level
            </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
        </div>

        <div className="ibj_filter_actions">
          <button type="button" className="ibj_btn_ghost" onClick={handleReset}>
            Reset
          </button>
          <button
            type="button"
            className="ibj_icon_btn"
            onClick={() => setIsReload(true)}
            title="Muat ulang"
          >
            <img src={RefreshIcon} alt="refresh" />
          </button>
        </div>
      </div>

      <div className="ibj_table_wrap">
        <table className="ibj_table">
          <thead>
            <tr>
              <th className="ibj_td_no">No</th>
              <th>Customer</th>
              <th>Produk</th>
              <th>OK</th>
              <th>NG</th>
              <th>Line</th>
              <th>Update By</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            {dataTemp &&
              dataTemp.map((e, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className="ibj_td_text">{e && e.company}</td>
                  <td className="ibj_td_text" style={{ textAlign: "left" }}>
                    {e && e.material}
                  </td>
                  <td className={okClass(e)}>{formatDot(e && e.dataWeight)}</td>
                  <td className="ibj_neg">{formatDot(e && e.dataReject)}</td>
                  <td>{e && e.statusBahan.toUpperCase()}</td>
                  <td>
                    {e && (e.updatedBy || "").split(" ").slice(0, 1).join(" ")}
                  </td>
                  <td className="ibj_td_text">{e && e.keterangan}</td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td className="ibj_td_text">JUMLAH</td>
              <td>{formatDot(sum && sum)}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <br />
    </div>
  );
};

export default InputBarangJadi;
